// Photo filenames for Holiday Party 2017
const HOLIDAY_PARTY_2017 = [
  'rolling-thunder-holiday-party-2017-15_38319510154_c.jpg',
  'rolling-thunder-holiday-party-2017-16_38319510014_z.jpg',
  'rolling-thunder-holiday-party-2017-17_39035349861_c.jpg',
  'rolling-thunder-holiday-party-2017-18_38319509944_c.jpg',
  'rolling-thunder-holiday-party-2017-21_39035349751_c.jpg',
  'rolling-thunder-holiday-party-2017-22_38319509854_z.jpg',
  'rolling-thunder-holiday-party-2017-24_39035349571_c.jpg',
  'rolling-thunder-holiday-party-2017-25_38319509714_c.jpg',
  'rolling-thunder-holiday-party-2017-26_39035349341_z.jpg',
  'rolling-thunder-holiday-party-2017-11_38319510454_l.jpg',
  'rolling-thunder-holiday-party-2017-12_25164495408_l.jpg',
  'rolling-thunder-holiday-party-2017-13_38319510314_c.jpg',
  'rolling-thunder-holiday-party-2017-14_25164495208_c.jpg',
];

export default HOLIDAY_PARTY_2017;
